module.exports = "/assets/login/loginFormPhoto.jpg?Y4hqNyJ";